import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForAssetFormatRelationComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'assetId', 'assetFormat', 'cmsState', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'assetId',
      type: 'relation',
    },
    {
      property: 'assetFormat',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
